import React, { Component } from "react";
import PaginatedDialogView from "../../components/PaginatedDialog/PaginatedDialogView";
import SharedViewProps from "../../../../../models/types/SharedViewProps";
import BillingInfoViewStyle from './BillingInfoViewStyle';
import DialogTextInputView from "../../components/DialogBase/components/DialogTextInput/DialogTextInputView";
import BillingInfoViewState from "./BillingInfoViewState";
import DialogAddressPickerView from "../../components/DialogBase/components/DialogAddressPicker/DialogAddressPickerView";
import PaginatedDialogFooterView from "../../components/PaginatedDialog/components/PaginatedDialogFooter/PaginatedDialogFooterView";

export default class BillingInfoView extends Component<SharedViewProps, BillingInfoViewState> {

    state = {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        company: '',
        taxNumber: '',
        billingAddress: '',
        errors: {
            firstName: '',
            lastName: '',
            email: '',
            phoneNumber: '',
            company: '',
            taxNumber: '',
            billingAddress: '',
        }
    }

    private _style = new BillingInfoViewStyle();

    private _onFirstNameChange = (firstName: string) => {
        const { errors } = this.state;

        errors.firstName = '';
        this.setState({ firstName, errors });
    }

    private _onLastNameChange = (lastName: string) => {
        const { errors } = this.state;

        errors.lastName = '';
        this.setState({ lastName, errors });
    }

    private _onEmailChange = (email: string) => {
        const { errors } = this.state;

        errors.email = '';
        this.setState({ email, errors });
    }

    private _onPhoneNumberChange = (phoneNumber: string) => {
        const { errors } = this.state;

        errors.phoneNumber = '';
        this.setState({ phoneNumber, errors });
    }

    private _onCompanyChange = (company: string) => {
        const { errors } = this.state;

        errors.company = '';
        this.setState({ company, errors });
    }

    private _onTaxNumberChange = (taxNumber: string) => {
        const { errors } = this.state;

        errors.taxNumber = '';
        this.setState({ taxNumber, errors });
    }

    private _onBillingAddressChange = (billingAddress: string) => {
        const { errors } = this.state;

        errors.billingAddress = '';
        this.setState({ billingAddress, errors });
    }

    private _onSubmit = (done: () => void) => {
        const { firstName, lastName, email, phoneNumber, company, taxNumber, billingAddress, errors } = this.state;

        if (!firstName || !lastName || !email || !phoneNumber || !company || !taxNumber || !billingAddress) {
            errors.firstName = !firstName ? 'requiredField' : '';
            errors.lastName = !lastName ? 'requiredField' : '';
            errors.email = !email ? 'requiredField' : '';
            errors.phoneNumber = !phoneNumber ? 'requiredField' : '';
            errors.company = !company ? 'requiredField' : '';
            errors.taxNumber = (!taxNumber || taxNumber.length != 12) ? 'requiredField' : '';
            errors.billingAddress = !billingAddress ? 'requiredField' : '';

            this.setState({ errors });
            done();

            return;
        }

        this.props.routeProps.history.push('payment', {
            ...this.props.routeProps.location.state,
            company: { name: company, companyNumber: taxNumber, address:billingAddress, language: this.props.routeProps.match.params.language },
            superior: {firstName, lastName, email, phoneNumber, language: this.props.routeProps.match.params.language}
        });
    }

    render() {
        const { errors } = this.state;
        return (
            <PaginatedDialogView title='oneShotCheckRequest' subtitle='billingInfo'>
                <div style={this._style.form}>
                    <div style={this._style.inputRow}>
                        <DialogTextInputView style={this._style.inputMargin} placeholder='companyPlaceholder' onChange={this._onCompanyChange} error={errors.company} />
                        <DialogTextInputView mask={"9999.999.999"} maskChar={"."} placeholder='companyNumberPlaceholder' onChange={this._onTaxNumberChange} value={this.state.taxNumber} error={errors.taxNumber} />
                    </div>

                    <DialogAddressPickerView
                        label='billingAddressPlaceholder'
                        onChange={this._onBillingAddressChange}
                        value={this.state.billingAddress}
                        error={errors.billingAddress} />
                        
                    <div style={this._style.inputRow}>
                        <DialogTextInputView style={this._style.inputMargin} placeholder='firstNamePlaceholder' onChange={this._onFirstNameChange} error={errors.firstName} />
                        <DialogTextInputView placeholder='lastNamePlaceholder' onChange={this._onLastNameChange} error={errors.lastName} />
                    </div>

                    <div style={this._style.inputRow}>
                        <DialogTextInputView style={this._style.inputMargin} placeholder='emailPlaceholder' onChange={this._onEmailChange} error={errors.email} />
                        <DialogTextInputView placeholder='phoneNumberPlaceholder' onChange={this._onPhoneNumberChange} error={errors.phoneNumber} />
                    </div>
                </div>

                <PaginatedDialogFooterView numberOfPages={5} currentPage={4} onSubmit={this._onSubmit} />
            </PaginatedDialogView>
        );
    }
}